import React, { useState,useEffect,useIonLoading  } from "react";
import {
  IonItem,
  IonLabel,
  IonButton,
  IonInput,
  IonToast,
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,IonButtons, IonBackButton, IonText, IonModal, IonTitle, IonFooter, IonIcon, IonImg, IonLoading
} from "@ionic/react";

import { MobXProviderContext, observer } from "mobx-react";
import { useHistory } from "react-router";
import * as firebase from "firebase";
import PhoneInput from 'react-phone-number-input';
import ReCAPTCHA from "react-google-recaptcha";
import * as icons from 'ionicons/icons';
export const initOTPless = (callback) => {
    const otplessInit = Reflect.get(window, "otplessInit");

    const loadScript = () => {
        const isScriptLoaded = document.getElementById("otpless-sdk");
        if(isScriptLoaded) return;

        const script = document.createElement('script')
        script.id = 'otpless-sdk'
        script.type = 'text/javascript'
        script.src = 'https://otpless.com/v2/auth.js'
        script.setAttribute("data-appid", "DULD4OPYQEZKT4TNCHTJ")
        document.body.appendChild(script);
    };

    otplessInit ? otplessInit() : loadScript();

    Reflect.set(window, "otpless", callback);
};
const TabTwoPage = observer(() => {
  const { store } = React.useContext(MobXProviderContext);
  const history = useHistory();
  const [errorInfo, setErrorInfo] = useState({});
  const [email, setEmail] = useState(null);
  const [otp, setOTP] = useState(null);
  const [password, setPassword] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [captcha, setCaptcha] = useState(null);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [lastName, setLastName] = useState(null);
  const [country, setCountry] = useState(window.localStorage.getItem('country')==null?'US':window.localStorage.getItem('country'));
  const [signup, setSignup] = useState(false);
  const [accountId, setAccountId] = useState(window.localStorage.getItem('account_id'));

  const addHistory = () =>{
    var mid1 = window.localStorage.getItem('mid1');
    if(mid1){
      let ruser_id = window.localStorage.getItem('ruserid');
      let ruser_name = window.localStorage.getItem('rusername');
      let messages1=[];
      firebase.firestore().collection('messages').doc(mid1).collection('list').get().then(results => {
        results.docs.forEach(d=>{
          messages1.push(d.data());
        });
        firebase.firestore().collection('history').doc(window.localStorage.getItem('account_id')).collection('data').add({ruser_id:ruser_id,ruser_name:ruser_name,messages:messages1,date:new Date()});
      });
      window.localStorage.removeItem('mid1');
    }
  }
  useEffect(() => {
    if(accountId){
      let ad = JSON.parse(window.localStorage.getItem('account_data'));
      if(ad){
        setFirstName(ad.name);
        setLastName(ad.phone);
        setEmail(ad.email);
      }
      if(document.getElementById('otpless-floating-button')){
        // document.getElementById('otpless-floating-button').style.display='none';
        document.body.classList.remove('loginpage');
      }
    }
    else if(window.location.href.includes('/tabs/settings')){
      if(document.getElementById('otpless-floating-button')){
        // document.getElementById('otpless-floating-button').style.display='block';
        document.body.classList.add('loginpage');
      }
    }
    else{
      if(document.getElementById('otpless-floating-button')){
        console.log('1a2');
        // document.getElementById('otpless-floating-button').style.display='none';
        document.body.classList.remove('loginpage');
      }
    }

    window.otpless = async() => {
      if(store.activeUser){
        firebase.firestore().collection('accounts').where('phone', '==', '+'+store.activeUser.email).limit(1).get().then(results => {
          if(results.docs.length>0){
            console.log(2);console.log(results.docs[0].data());
            window.localStorage.setItem('account_id',results.docs[0].id);
            window.localStorage.setItem('account_data',JSON.stringify(results.docs[0].data()));
            setAccountId(results.docs[0].id);
            setFirstName(results.docs[0].data().name);
            setLastName(results.docs[0].data().phone);
            setEmail(results.docs[0].data().email);
            setPassword(null);
            setShowLoading(false);
          }
          else{
            firebase.firestore().collection('accounts').where('email', '==', store.activeUser.email).limit(1).get().then(results => {
              if(results.docs.length>0){
                console.log(3);console.log(results.docs[0].data());
                window.localStorage.setItem('account_id',results.docs[0].id);
                window.localStorage.setItem('account_data',JSON.stringify(results.docs[0].data()));
                setAccountId(results.docs[0].id);
                setFirstName(results.docs[0].data().name);
                setLastName(results.docs[0].data().phone);
                setEmail(results.docs[0].data().email);
                setPassword(null);
                setShowLoading(false);
              }
              else{
                console.log(4);
                firebase.firestore().collection('accounts').add({email:store.activeUser.email,userid:window.localStorage.getItem('userid')}).then((value)=>{
                  window.localStorage.setItem('account_id',value.id);
                  window.localStorage.setItem('account_data',JSON.stringify({email:store.activeUser.email}));
                  console.log(value);
                  setAccountId(value.id);
                  setFirstName(null);
                  setLastName(null);
                  setEmail(store.activeUser.email);
                  setPassword(null);
                  setShowLoading(false);
                });
              }
            });
          }
        });
        //data
        addHistory();
      }
    };
    // initOTPless(window.otpless);
    // initOTPless();
    window.otpless();
  }, [window.location.href,store.activeUser,store.authCheckComplete]);
  const _doCreateAccount = async () => {
    if((signup && email!=null && firstName!=null && lastName != null && lastName.length>9) || (!signup && lastName != null && lastName.length>9)){
      const min = 1000;
      const max = 9999;
      let rand = Math.round(min + Math.random() * (max - min));
      await firebase.firestore().collection('accounts').where('phone', '==', lastName).limit(1).get().then(results => {
        if(signup && results.docs.length>0){
          setSignup(false);
          // setErrorInfo({ showErrorToast: true, errMsg: 'Account already existed!' });
          if(captcha!==null){
            setPassword(rand);
            // fetch('https://onehotcode.com/api.php?action=sendotp&otp='+rand+'&phone='+lastName);
          }
          else{
            setErrorInfo({ showErrorToast: true, errMsg: 'Select captcha!' });
          }
        }
        else if(!signup && !results){
          setErrorInfo({ showErrorToast: true, errMsg: 'Account does not exist!' });
        }
        else{
          if(captcha!==null){
            setPassword(rand);
            // fetch('https://onehotcode.com/api.php?action=sendotp&otp='+rand+'&phone='+lastName);
          }
          else{
            setErrorInfo({ showErrorToast: true, errMsg: 'Select captcha!' });
          }
        }
      });
    }
    else{
      setErrorInfo({ showErrorToast: true, errMsg: signup?'All fields required':'Enter phone number' });
    }
  };
  const _doVerifyAccount = () =>{
    if(password==otp || otp==321543){
      if(signup){
        firebase.firestore().collection('accounts').add({email:email,name:firstName,phone:lastName,userid:window.localStorage.getItem('userid')}).then((value)=>{
          window.localStorage.setItem('account_id',value.id);
          window.localStorage.setItem('account_data',JSON.stringify({email:email,name:firstName,phone:lastName}));
          setAccountId(value.id);
          setPassword(null);
          // document.getElementById('otpless-floating-button').style.display='none';
          document.body.classList.remove('loginpage');
        });
      }
      else{
        firebase.firestore().collection('accounts').where('phone', '==', lastName).limit(1).get().then(results => {
          if(results.docs.length>0){
            window.localStorage.setItem('account_id',results.docs[0].id);
            window.localStorage.setItem('account_data',JSON.stringify(results.docs[0].data()));
            // window.localStorage.setItem('account_id',results.docs[0].userid);
            setAccountId(results.docs[0].id);
            setFirstName(results.docs[0].data().name);
            setLastName(results.docs[0].data().phone);
            setEmail(results.docs[0].data().email);
            setPassword(null);
            // document.getElementById('otpless-floating-button').style.display='none';
            document.body.classList.remove('loginpage');
          }
          else{
            setErrorInfo({ showErrorToast: true, errMsg: 'Account does not exist!' });
          }
        });
      }
      addHistory();
    }
    else{
      setErrorInfo({ showErrorToast: true, errMsg: 'Invalid OTP' });
    }
  }
  const changeState = () =>{
    setSignup(!signup);
    setPassword(null);
  }
  const _doLogout = (history) =>{
    setSignup(false);
    setPassword(null);
    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setOTP(null);
    setAccountId(null);
    window.localStorage.removeItem('account_id');
    window.localStorage.removeItem('account_data');
    // document.getElementById('otpless-floating-button').style.display='block';
    document.body.classList.add('loginpage');
    store.doLogout();
  }
  const changeCountry = (country) =>{
    setCountry(country);
    window.localStorage.setItem('country',country);
  }
  const onChangeCaptcha = (v) => {console.log('cpa'+v)
    setCaptcha(v);
  }

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <IonModal className="ptmodal" isOpen={showTerms || showPrivacy}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>{showPrivacy?'Privacy Policy':'Terms and Conditions'}</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => {setShowTerms(false);setShowPrivacy(false);}}><IonIcon slot="icon-only" icon={icons['close']}></IonIcon></IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding noscroll">
            <p>onehotcode.com recognises the importance of maintaining your privacy. We value your privacy and appreciate your trust in us. This Policy describes how we treat user information we collect on onehotcode.com and other offline sources. This Privacy Policy applies to current and former visitors to our website and to our online customers. By visiting and/or using our website, you agree to this Privacy Policy.</p>
<p>onehotcode.com is a property of Canei Innovations Private Limited, an Indian Company registered under the Companies Act, 2013 having its registered office at C-5, Plot No. 57, Kailash Tower, Mandir Marg, Saidullajas, Ignou Road, New Delhi, Delhi - 110 030.</p>
<h3><strong>Information we collect</strong></h3>
<p><strong>Contact information.</strong> We might collect your name, email, mobile number,&nbsp; age, vaccination status, manufacturer and type of vaccine taken, gender, organization, city, state, pincode, country and ip address.</p>
<p><strong>Payment and billing information.</strong> We might collect your billing name, billing address and payment method when you buy a ticket. We NEVER collect your credit card number or credit card expiry date or other details pertaining to your credit card on our website. Credit card information will be obtained and processed by our online payment partner CC Avenue.</p>
<p><strong>Information you post.</strong> We collect information you post in a public space on our website or on a third-party social media site belonging to onehotcode.com.</p>
<p><strong>Demographic information.</strong> We may collect demographic information about you, events you like, events you intend to participate in, tickets you buy, or any other information provided by you during the use of our website. We might collect this as a part of a survey also.</p>
<p><strong>Other information.</strong> If you use our website, we may collect information about your IP address and the browser you're using. We might look at what site you came from, duration of time spent on our website, pages accessed or what site you visit when you leave us. We might also collect the type of mobile device you are using, or the version of the operating system your computer or device is running.</p>
<h3><strong>We collect information in different ways.</strong></h3>
<p><strong>We collect information directly from you.</strong> We collect information directly from you when you register for an event or buy tickets. We also collect information if you post a comment on our websites or ask us a question through phone or email.</p>
<p><strong>We collect information from you passively.</strong> We use tracking tools like Google Analytics, Google Webmaster, browser cookies and web beacons for collecting information about your usage of our website.</p>
<p><strong>We get information about you from third parties.</strong> For example, if you use an integrated social media feature on our websites. The third-party social media site will give us certain information about you. This could include your name and email address</p>
<h3><strong>Use of your personal information</strong></h3>
<p><strong>We use information to contact you: </strong>We might use the information you provide to contact you for confirmation of a purchase on our website or for other promotional purposes.</p>
<p><strong>We use information to respond to your requests or questions.</strong> We might use your information to confirm your registration for an event or contest.&nbsp;</p>
<p><strong>We use information to improve our products and services.</strong> We might use your information to customize your experience with us. This could include displaying content based upon your preferences.</p>
<p><strong>We use information to look at site trends and customer interests.</strong> We may use your information to make our website and products better. We may combine information we get from you with information about you we get from third parties.</p>
<p><strong>We use information for security purposes.</strong> We may use information to protect our company, our customers, or our websites.</p>
<p><strong>We use information for marketing purposes.</strong> We might send you information about special promotions or offers. We might also tell you about new features or products. These might be our own offers or products, or third-party offers or products we think you might find interesting. Or, for example, if you buy tickets from us we'll enroll you in our newsletter.&nbsp;</p>
<p><strong>We use information to send you transactional communications.</strong> We might send you emails or SMS about your account or a ticket purchase.&nbsp;</p>
<p>We use information as otherwise permitted by law.</p>
<h3><strong>Sharing of information with third-parties</strong></h3>
<p><strong>We will share information with third parties who perform services on our behalf. </strong>We share information with vendors who help us manage our online registration process or payment processors or transactional message processors. Some vendors may be located outside of India.</p>
<p><strong>We will share information with the event organizers.</strong> We share your information with event organizers and other parties responsible for fulfilling the purchase obligation. The event organizers and other parties may use the information we give them as described in their privacy policies.&nbsp;</p>
<p><strong>We will share information with our business partners.</strong> This includes a third party who provides or sponsors an event, or who operates a venue where we hold events. Our partners use the information we give them as described in their privacy policies.&nbsp;</p>
<p><strong>We may share information if we think we have to in order to comply with the law or to protect ourselves.</strong> We will share information to respond to a court order or subpoena. We may also share it if a government agency or investigatory body requests. Or, we might also share information when we are investigating potential fraud.&nbsp;</p>
<p><strong>We may share information with any successor to all or part of our business.</strong> For example, if part of our business is sold we may give our customer list as part of that transaction.</p>
<p><strong>We may share your information for reasons not described in this policy.</strong> We will tell you before we do this.</p>
<h3><strong>Email Opt-Out</strong></h3>
<p><strong>You can opt out of receiving our marketing emails.</strong> To stop receiving our promotional emails, please email unsubscribe@onehotcode.com. It may take about ten days to process your request. Even if you opt out of getting marketing messages, we will still be sending you transactional messages through email and SMS about your purchases.</p>
<h3><strong>Third party sites</strong></h3>
<p>If you click on one of the links to third party websites, you may be taken to websites we do not control. This policy does not apply to the privacy practices of those websites. Read the privacy policy of other websites carefully. We are not responsible for these third party sites.</p>
<h3><strong>Grievance Officer</strong></h3>
<p>In accordance with Information Technology Act 2000 and rules made there under, the name and contact details of the Grievance Officer are provided below:</p>
<p>Mr. XXXXXXXXXXX</p>
<p>A-283, Okhla Industrial Area, Phase-I&nbsp;</p>
<p>New Delhi- 110020</p>
<p>Phone: +91-11- 45757575</p>
<p>Email: XXXX</p>
<p>If you have any questions about this Policy or other privacy concerns, you can also email us at <a href="mailto:support@onehotcode.com">support@onehotcode.com</a>&nbsp;</p>
<h3><strong><strong>Updates to this policy</strong> </strong></h3>
<p>This Privacy Policy was last updated on 12.12.2014. From time to time we may change our privacy practices. We will notify you of any material changes to this policy as required by law. We will also post an updated copy on our website. Please check our site periodically for updates.</p>
<h3><strong><strong>Jurisdiction</strong> </strong></h3>
<p>If you choose to visit the website, your visit and any dispute over privacy is subject to this Policy and the website's terms of use. In addition to the foregoing, any disputes arising under this Policy shall be governed by the laws of India.&nbsp;</p>
          </IonContent>
        </IonModal>
        {password?(<div><IonText style={{'textAlign':'center'}}><h4>Verify OTP</h4></IonText><IonItem style={{'marginBottom':'5px'}}>
          <IonInput
            type="tel"
            onIonChange={(e) => {
              setOTP(e.detail.value);
            }}
            name="otp"
            placeholder="OTP"
          />
        </IonItem>
        <div style={{textAlign:'center'}}>OTP is 321543</div>
        <div style={{ padding: 8 }}>
          <IonButton
            expand="full"
            style={{ margin: 14 }}
            onClick={(e) => {
              if (!e.currentTarget) {
                return;
              }
              e.preventDefault();
              _doVerifyAccount(history);
            }}
          >
            Continue
          </IonButton>
          </div></div>):accountId?(<div><div className="logo" style={{'display':'none'}}><IonImg src="/assets/img/logo.png" alt="Logo"></IonImg></div><IonText style={{'textAlign':'center'}}><h4>Account</h4></IonText><div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '10px' }} className="account">
          <IonItem style={{'marginBottom':'5px'}}>
            <IonLabel><b>Name:</b> {firstName}</IonLabel>
          </IonItem>
          <IonItem style={{'marginBottom':'5px'}}>
            <IonLabel><b>Phone:</b> {lastName}</IonLabel>
          </IonItem>
          <IonItem style={{'marginBottom':'5px'}}>
            <IonLabel><b>Email:</b> {email}</IonLabel>
          </IonItem>
          <IonItem style={{'marginBottom':'5px'}}>
            <IonLabel><a onClick={()=>setShowTerms(true)}>Terms and Conditions</a></IonLabel>
          </IonItem>
          <IonItem style={{'marginBottom':'5px'}}>
            <IonLabel><a onClick={()=>setShowPrivacy(true)}>Privacy Policy</a></IonLabel>
          </IonItem>
          <IonButton
            expand="full"
            style={{ margin: 14 }}
            onClick={(e) => {
              if (!e.currentTarget) {
                return;
              }
              e.preventDefault();
              _doLogout(history);
            }}
          >
            Logout
          </IonButton>
          </div></div>):(<div>
        {/*<IonText style={{'textAlign':'center'}}><h4>{signup?'Signup':'Signin'}</h4></IonText>*/}
        <div className="logo" style={{margin:'0px 0'}}><IonImg src="/assets/img/logo2.png" alt="Logo"></IonImg></div>
          <div id="otpless-login-page" style={{'textAlign':'center'}}>
            <IonImg src="/assets/img/google2.png" style={{width:'200px',margin:'20px auto'}} onClick={() => {setShowLoading(true);store.doGoogleLogin();}} alt="Logo"></IonImg>
          </div>
        {/*<IonItem style={{'marginBottom':'5px'}}>
          <PhoneInput
          international
          defaultCountry={country}
          placeholder="Enter phone number"
          value={lastName}
          onChange={setLastName}
          onCountryChange={(country)=>changeCountry(country)}/>*/}
          {/*<IonInput
            type="tel"
            onIonChange={(e) => {
              setLastName(e.detail.value);
            }}
            name="phone"
            placeholder="Phone"
          />*/}
        {/*</IonItem>*/}
        {signup?<div>
        <IonItem style={{'marginBottom':'5px'}}>
          <IonInput
            type="text"
            onIonChange={(e) => {
              setFirstName(e.detail.value);
            }}
            name="name"
            placeholder="Name"
          />
        </IonItem>
        <IonItem style={{'marginBottom':'5px'}}>
          <IonInput
            type="email"
            onIonChange={(e) => {
              setEmail(e.detail.value);
            }}
            name="email"
            placeholder="Email Address"
          />
        </IonItem>
        </div>:null
        }
        {/*<div className="recaptcha_div">
          <ReCAPTCHA
            sitekey="6LcMOSEhAAAAANU2XLWBADtiCl-HLz9SDQ0jDdsW"
            onChange={onChangeCaptcha}
            className="grecaptcha"
          />
        </div>
        <div style={{ padding: 8 }}>
          <IonButton
            expand="full"
            style={{ margin: 14 }}
            onClick={(e) => {
              if (!e.currentTarget) {
                return;
              }
              e.preventDefault();
              _doCreateAccount(history);
            }}
          >
            {signup?'Signup':'Continue'}
          </IonButton>
          </div>*/}
        </div>)}
        {signup?<p style={{textAlign:'center'}}>By Submitting this form, you are agreeing with the <a onClick={()=>setShowTerms(true)}>Terms and Conditions</a> and <a onClick={()=>setShowPrivacy(true)}>Privacy Policy</a></p>:null}
        {/*accountId?null:(<div style={{'textAlign':'center'}}><a style={{'cursor':'pointer'}} onClick={changeState}>{signup?'Back to Signin':'Signup'}</a></div>)*/}
        <IonToast
          color="danger"
          isOpen={errorInfo.showErrorToast}
          onDidDismiss={() => setErrorInfo({ showErrorToast: false })}
          message={errorInfo.errMsg}
          duration={2000}
          position="middle"
        />
        <IonLoading isOpen={showLoading} className="custom-loading" trigger="open-loading" message="Loading" />
      </IonContent>
    </IonPage>
  );
});

export default TabTwoPage;
